import { useContext } from "react";

import { AudioControlsContext } from "../context/audio-controls-context";

export const useAudioControls = () => {
  const context = useContext(AudioControlsContext);
  if (!context) {
    throw new Error("useAudioControls must be used within an AudioControlsProvider");
  }
  return context;
};
